import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//API
import ItemService from "../../../../../services/customer_appCommonService";

//Redux
import { useDispatch, useSelector } from "react-redux"; //useDispatch

//Components
import { InputField } from "../../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../../Components/formElements/ComboboxField";
import DataTable from "react-data-table-component";
// import Constants from "../../../../../common/SupplierConstants";
import FailureModal from "../../../../../Components/Modal/supplier_app/FailureModal";
import {
  validateName,
  // validateRequired,
  validPostalCode,
} from "../../../../../common/Validations";
import toast from "react-hot-toast";
import FileUploadComponent from "../../../../../Components/formElements/FileUploadComponent";
import Loader from "../../../../../Components/Loader";
import Layout from "../../../../../Layout/Layout";
import RichTextEditor from "../../../../../Components/Editor/RichTextEditor";
import { getLoginUserData } from "../../../../../redux/feature/userSlice";
import ApproveRemarksModal from "../../../../../Components/Modal/supplier_app/ApproveRemarksModal";
import { useReactToPrint } from "react-to-print";
// import PrintKYCRegistration from "../KYCForm/PrintKYCRegistration";
import FileViewerModal from "../../../../../Components/FileViewer/FileViewerModal";
// import { hasAccess } from "../../../../../utils/roleUtils";
import LogisticsConstants from "../../../../../common/LogisticsConstants";
// import { kycExistingCustomer } from "../../../../redux/feature/customer_app/customerV1Slice";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
};

const PlTransporterRegistrationDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Transporter");

  // let customerData = useSelector((state) => state?.customer?.data); // User Details from Store
  let transporterID = useSelector((state) => state?.logistics?.transporter?.transporterNr); // User Details from Store
  let workflow = useSelector((state) => state?.customer?.customerWorkflow); // workflow from Store

  // console.log("customerID",customerID)
  // const SalesOfficerData = [
  //   { id: 4, code: "A000", name: "Amarendra" },
  //   { id: 1, code: "S0001", name: "Manjunatha" },
  //   { id: 2, code: "S0002", name: "Umesh" },
  //   { id: 3, code: "S0003", name: "Amith" },
  //   { id: 4, code: "S0004", name: "Sathish" },
  // ];
  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  // eslint-disable-next-line no-unused-vars
  const [getPaymentTypeStatus, setPaymentTypeStatus] = useState("");

  const [editMode, setEditMode] = useState(true);

  // let requiredFields = [];
  

  const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible11, setCardVisible11] = useState(true);
  const [isCardVisible12, setCardVisible12] = useState(true);

  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields /* setErrorFields */] = useState([]);
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getTitle, setTitle] = useState([]);
  const [loading, setLoading] = useState(false);

  const [modalShowApprove, setModalShowApprove] = useState(false);
  const [getAction, setAction] = useState("");

  const [editorContent, setEditorContent] = useState(""); //remarks

  const [getcustomerContactPerson, setcustomerContactPerson] = useState([
    {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    },
  ]);
  // console.log(">>getcustomerContactPerson", getcustomerContactPerson);
  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "29AADCN1012B1Z6",
    },
  ]);

  // eslint-disable-next-line no-unused-vars
  // const [getProjectContactPerson, setProjectContactPerson] = useState([
  //   {
  //     id: Date.now(),
  //     projectContactPosition: "",
  //     projectContactTitle: "",
  //     projectContactName: "",
  //     projectContactNumber: "",
  //     projectContactEmail: "",
  //   },
  // ]);

  const [getdocumentType, setdocumentType] = useState([]);

  const [getState, setState] = useState([]);
  const [getCountry, setCountry] = useState([]);

  const [validation, setValidation] = useState({
    organisationName: "",
    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
  });

  // ADD new projects
  // const newProject = {
  //   projectCode: 1,
  //   projectCodeDesc: "PROJECT_1",
  //   projectName: "",
  //   projectAddress: "",
  //   projectAddress2: "",
  //   projectCity: "",
  //   projectCountry: "IN - India",
  //   projectState: "IN - Karanataka",
  //   projectCityPostalCode: "",
  //   getProjectContactPerson: [
  //     {
  //       id: Date.now(), // Unique ID for the first contact person
  //       projectContactPosition: "",
  //       projectContactTitle: "",
  //       projectContactName: "",
  //       projectContactNumber: "",
  //       projectContactEmail: "",
  //     },
  //   ],
  //   getProjectCertifications: [
  //     {
  //       id: Date.now(),
  //       name: "",
  //       documentType: "",
  //       certificateCode: "",
  //     },
  //   ],
  //   getLocations: [],
  // };


  const [getprojectCompletedData, setprojectCompletedData] = useState();

  const [getCompanyCode, setCompanyCode] = useState([]);

  //bank details
  const [getBankDetails, setBankDetails] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [getBankDetailsData, setBankDetailsData] = useState([]);

  /* project completed data and col */
  let projectCompletedCol = [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      sortable: true,
      width: "80px",
    },
    {
      name: "Project Name",
      selector: (row) => row.projectNameCopleted || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="projectNameCopleted"
          placeholder=""
          value={row.projectNameCopleted || ""}
          onChange={(event) =>
            handleInputFieldChangeCompleted(row.local_id, event)
          }
          disabled={editMode}
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Project Tenure",
      selector: (row) => row.projectTenureCompleted || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="projectTenureCompleted"
          placeholder=""
          value={row.projectTenureCompleted || ""}
          disabled={editMode}
          onChange={(event) =>
            handleInputFieldChangeCompleted(row.local_id, event)
          }
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Start Date",
      selector: (row) => row.startDateCompleted || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="startDateCompleted"
          placeholder=""
          type="date"
          value={row.startDateCompleted || ""}
          disabled={editMode}
          onChange={(event) =>
            handleInputFieldChangeCompleted(row.local_id, event)
          }
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "End Date",
      selector: (row) => row.endDateCompleted || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="endDateCompleted"
          type="date"
          placeholder=""
          value={row.endDateCompleted || ""}
          disabled={editMode}
          onChange={(event) =>
            handleInputFieldChangeCompleted(row.local_id, event)
          }
        />
      ),
      width: "220px",
    },

    {
      name: "Delete",
      omit: editMode ? true : false,
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button onClick={() => removeProjecetDocumentItemRow(row.local_id)}>
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];
  let projectCompletedData = [
    {
      local_id: 1,
      projectNameCopleted: "",
      projectTenureCompleted: "",
      startDateCopleted: "",
      endDateCopleted: "",
      statusCopleted: "",
    },
  ];

  // Project on Hand col and Data
  let projectOnHandCol = [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      sortable: true,
      width: "80px",
    },
    {
      name: "Project Name",
      selector: (row) => row.projectNameOnHand || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="projectNameOnHand"
          placeholder=""
          value={row.projectNameOnHand || ""}
          disabled={editMode}
          onChange={(event) => handleInputChangeOnHand(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Project Tenure",
      selector: (row) => row.projectTenureOnHand || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="projectTenureOnHand"
          placeholder=""
          value={row.projectTenureOnHand || ""}
          disabled={editMode}
          onChange={(event) => handleInputChangeOnHand(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Start Date",
      selector: (row) => row.startDateOnHand || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="startDateOnHand"
          type="date"
          placeholder=""
          value={row.startDateOnHand || ""}
          disabled={editMode}
          onChange={(event) => handleInputChangeOnHand(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Tentative Date",
      selector: (row) => row.endDateOnHand || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="endDateOnHand"
          type="date"
          placeholder=""
          value={row.endDateOnHand || ""}
          disabled={editMode}
          onChange={(event) => handleInputChangeOnHand(row.local_id, event)}
        />
      ),
      width: "220px",
    },
    {
      name: "Delete",
      omit: editMode ? true : false,
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          onClick={() => removeprojectDetailContactPersonItemRow(row.local_id)}
        >
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];
  let projectOnHandData = [
    {
      local_id: 1,
      projectNameOnHand: "",
      projectTenureOnHand: "",
      startDateOnHand: "",
      endDateOnHand: "",
      statusOnHand: "",
    },
  ];

  const [getProjectOnHandData, setProjectOnHandData] = useState();

  const [getCustomerProfile, /*setCustomerProfile*/] = useState();

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility11 = () => {
    setCardVisible11(!isCardVisible11);
  };
  const toggleCardVisibility12 = () => {
    setCardVisible12(!isCardVisible12);
  };

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
    validateName(name === "organisationName" ? value : "")
      ? (errors.organisationName = "")
      : (errors.organisationName = message.VALID_CUSTOMER_NAME);
    validPostalCode(name === "cityPostalCode" ? value : "")
      ? (errors.cityPostalCode = "")
      : (errors.cityPostalCode = message.VALID_POSTAL_CODE);

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const [formInputs, setFormInputs] = useState({
    userId: transporterID,
    organisationName: "",
    address: "",
    address2: "",
    city: "",
    country: "IN - India",
    state: "IN - Karnataka",
    cityPostalCode: "",

    version: "v0",
    status: "Non Invited",
    category: "VENDOR",

    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
    salesOfficerName: "",

    plantAddress:
      "Bharathi Rock Products India PVT Ltd Sy No.9, Kanivenarayanapura(V), Muddenahalli Post,Chikkabalapura-562101",
    projectLocation: "",

    customerTypeCode: "C03",
    customerTypeDesc: "Domestic",
  });

  // eslint-disable-next-line no-unused-vars
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    // dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
    getMasterData();
  }, [dispatch]);

  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);
    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    } else if (getDropdownData?.codeType === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // getStateData(getDropdownData?.code);
    } else if (getDropdownData?.codeType === "jobtitle") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
              ...doc,
              [getDropdownData?.textField]: getDropdownData?.name,
              [getDropdownData?.textCode]: getDropdownData?.code,
              [getDropdownData?.textDesc]: getDropdownData?.description,
            }
            : doc
        )
      );
    } else if (getDropdownData?.codeType === "title") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
              ...doc,
              [getDropdownData?.textField]: getDropdownData?.name,
              [getDropdownData?.textCode]: getDropdownData?.code,
              [getDropdownData?.textDesc]: getDropdownData?.description,
            }
            : doc
        )
      );
    } else if (getDropdownData?.codeType === "documentType") {
      setDocumentTypeData((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
              ...doc,
              [getDropdownData?.textField]: getDropdownData?.name,
              [getDropdownData?.textCode]: getDropdownData?.code,
              [getDropdownData?.textDesc]: getDropdownData?.description,
            }
            : doc
        )
      );
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);
  // console.log(">> formInputs", formInputs);

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj1 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj2 = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterDataSelf(obj2).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setcontactPosition(item?.data);
      } else {
        setcontactPosition([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj3 = {
      codeType: "country",
    };
    await ItemService.getMasterDataSelf(obj3).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj5 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj5).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };
  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setState(item?.data);
      } else {
        setState([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // eslint-disable-next-line no-unused-vars
  //   const navigateToLogin = () => {
  //     navigate(Constants.LOGIN);
  //   };

  /* ---------------------Customer Contact Person -------- */

  const deleteCustomerContactPerosn = (id) => {
    const updatedData1 = getcustomerContactPerson.filter(
      (doc) => doc.id !== id
    );
    setcustomerContactPerson(updatedData1);
  };
  const addCustomerCantactPerson = () => {
    const newDocument = {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    };
    setcustomerContactPerson((prevData) => [...prevData, newDocument]);
  };
  const handleChangeCustomerContacts = (id, fieldName, value) => {
    setcustomerContactPerson((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );
  };

  /* ---------------------Document Type  03rd block-------- */

  const deleteDocumentType = (id) => {
    const updatedData1 = getDocumentTypeData.filter((doc) => doc.id !== id);
    setDocumentTypeData(updatedData1);
  };
  const addDocumentType = () => {
    const newDocument = {
      id: Date.now(),
      name: `Document ${getDocumentTypeData.length + 1}`,
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "",
    };
    setDocumentTypeData((prevData) => [...prevData, newDocument]);
  };
  const handleInputChange = (id, fieldName, value) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );
  };

  /* ---------------------project Certifications  -------- */

  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc
      )
    );
  };

  //document upload for projects
  const loadFirstLevelData = async (page) => {
    // setLoading(true);
    // console.log(">> customerID", customerID);
    if (transporterID !== "") {
      let obj = {
        documentNumber: transporterID,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.getCustomerDetail(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          setFormInputs(item?.data[0]);
          setcustomerContactPerson(item?.data[0]?.contactDetails || []);
          setDocumentTypeData(item?.data[0]?.certifications || []);
          console.log("contactpe",item?.data[0]?.contactDetails)
          // setProjectDetails(item?.data[0]?.projectDetails || newProject);

          // setCompanyProfile(item?.data[0]?.companyProfile || []);
          // setprojectCompletedData(item?.data[0]?.projectCompleted || []);
          // setProjectOnHandData(item?.data[0]?.porjectOnHand || []);
          // setCustomerProfile(item?.data[0]?.customerProfile || []);
          // setFinancialTurnover(item?.data[0]?.financialTurnover || []);
          setBankDetails(item.data[0]?.bandkDetails);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      setLoading(false);
    } else {
      navigate(LogisticsConstants.LOGISTICS_MASTER_TRANSPORTER_LIST);
    }
  };

  useEffect(() => {
    loadFirstLevelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editCustomer = () => {
    setEditMode(false);
  };
  const canelUpdate = () => {
    setEditMode(true);
  };

  // SAVE
  const handleUpdate = async () => {
    // const requiredFields = [];
    // const anyFieldNotEmpty = Object.values(validation).some(
    //   (value) => value !== null && value !== ""
    // );
    // if (anyFieldNotEmpty) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }
    // if (!validateRequired(formInputs.organisationName)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     organisationName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.address)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     address: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.address2)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     address2: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.city)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     city: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.cityPostalCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     cityPostalCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    // if (!validateRequired(formInputs.distance)) {
    //   requiredFields.push(`${message.GET_MAP_DISTANCE}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   // setValidation((prev) => ({
    //   //   ...prev,
    //   //   cityPostalCode: message.FILL_REQUIRED_FIELD,
    //   // }));
    //   return;
    // }
    // if (!validateRequired(formInputs.salesOfficerName)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     salesOfficerName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    // if (!validateRequired(formInputs.routeNumber)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     routeNumber: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    // formInputs.userId = customerID;
    formInputs.contactDetails = getcustomerContactPerson.map((doc) => ({
      ...doc,
      contactPosition: `${doc.contactPositionCode || ""} - ${doc.contactPositionDesc || ""}`,
      contactTitle: `${doc.contactTitleCode || ""} `,
    }));

    formInputs.certifications = getDocumentTypeData.map((doc) => ({
      ...doc,
  
      documentType: `${doc.documentTypeCode || ""} - ${doc.documentTypeDesc || ""}`,
  
    }));
    // formInputs.contactDetails = getcustomerContactPerson;
    // formInputs.certifications = getDocumentTypeData;
    // formInputs.projectDetails = getProjectDetails;
    // formInputs.companyProfile = getCompanyProfile;
    // formInputs.projectCompleted = getprojectCompletedData;
    // formInputs.financialTurnover = getFinancialTurnover;
    formInputs.porjectOnHand = getProjectOnHandData;
    formInputs.customerProfile = editorContent;

    setDisabled(true);
    await ItemService.updateCustomerV1(formInputs).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        navigate(LogisticsConstants.LOGISTICS_MASTER_TRANSPORTER_LIST);
        // navigate(CustomerConstants.CUSTOMER_V1_COSTING_SHEET);
        // dispatch(saveCustomerRegData(item?.data));
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };


  // Approve
  const workflowApproveReject = async (remarks) => {
    let obj = {};
    let bodyObj = workflow?.workflow_record?.workflowActionAPI?.Body;

    obj._id = workflow?.workflow_record?._id;
    obj.businessComponentId = workflow?.workflow_record?.businessComponentId;
    obj.eventId = workflow?.workflow_record?.eventId;
    obj.businessComponentInstanceId =
      workflow?.workflow_record?.businessComponentInstanceId;
    obj.stepId = workflow?.workflow_record?.stepId;
    obj.action = getAction;
    obj.remark = remarks;
    obj.editContextData = workflow?.workflow_record?.editContextData;
    obj.editForm = workflow?.workflow_record?.editForm;
    // obj.data = {
    //   items: data,
    // };
    let newObj = { ...bodyObj, ...obj };

    // console.log(">> obj", obj);

    //Approve
    await ItemService.workflowApproveReject(newObj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        // navigate(Constants.INBOX);
        dispatch(getLoginUserData());
      } else {
        console.log(">> Error: Loading workflowApproveReject");
      }
    });
  };

  const showApproveModal = async (name) => {
    setModalShowApprove(true);
    setAction(name);
  };
  const hideModalApprove = () => {
    setModalShowApprove(false);
  };

  const handleValueChange = (remarks) => {
    workflowApproveReject(remarks);
  };

  const navigateToWorkflow = () => {
    if (workflow?.page === "Inbox") {
      //   navigate(Constants.INBOX);
    } else {
      //   navigate(Constants.OUTBOX);
    }
  };

  // console.log(">> workflow", workflow);

  //print
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `KYC_${Math.floor(Math.random() * 1000000)}`,
  });
  
  // project completed
  const removeProjecetDocumentItemRow = (local_id) => {
    setprojectCompletedData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id)
    );
  };
  const addProjecetDocumentItemRow = () => {
    setprojectCompletedData((prevRows) => {
      projectCompletedData[0].local_id = prevRows.length + 1;
      projectCompletedData[0].purchasingReqDocumentItemNr = prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...projectCompletedData];
    });
  };

  const handleInputFieldChangeCompleted = (local_id, event) => {
    const { name, value } = event.target;

    setprojectCompletedData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
  };
  /* Project on Hand  */
  const removeprojectDetailContactPersonItemRow = (local_id) => {
    setProjectOnHandData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id)
    );
  };
  const addprojectDetailContactPersonItemRow = () => {
    setProjectOnHandData((prevRows) => {
      projectOnHandData[0].local_id = prevRows.length + 1;
      projectOnHandData[0].purchasingReqDocumentItemNr = prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...projectOnHandData];
    });
  };

  const handleInputChangeOnHand = (local_id, event) => {
    const { name, value } = event.target;
    setProjectOnHandData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
  };
  //remarks
  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };


  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Transporter Details :{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {transporterID}
              </span>
               {formInputs?.activeInactive ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    Active
                  </span>
                ) : (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    Inactive
                  </span>
                )}
            </h2>
            <p className="subText">Transporter Registration Information </p>
            <hr />

            <div className="pageFooter mb-4">
              <Row>
                {workflow?.workflow_record?.decision?.length > 0 && (
                  <Col xs={12} md={4} lg={4} className="text-left">
                    <button
                      className="btnBack"
                      onClick={() => navigateToWorkflow()}
                    >
                      <i className="bi bi-arrow-return-left"></i> Go Back
                    </button>
                  </Col>
                )}
                <Col xs={12} md={8} lg={8} className="text-right">
                  {workflow?.workflow_record?.decision?.length > 0 &&
                    workflow?.workflow_record?.decision?.map((item, index) => (
                      <button
                        className={
                          item === "Approve" || item === "Submit"
                            ? "btnCommon btn-approve"
                            : "btnCommon btn-danger"
                        }
                        onClick={() => showApproveModal(item)}
                        key={index}
                      >
                        <i
                          className={
                            item === "Approve" || item === "Submit"
                              ? "bi bi-check2-circle"
                              : "bi bi-x-circle"
                          }
                        ></i>{" "}
                        {item}
                      </button>
                    ))}
                </Col>
              </Row>
            </div>

            {/* {JSON.stringify(workflow) !== "{}" && ( */}
            {JSON.stringify(workflow) === "{}" && (
              <Row className="mb-4">
                {!editMode && (
                  <Col
                    xs={6}
                    md={{ span: 2, offset: 8 }}
                    lg={{ span: 2, offset: 8 }}
                    className="text-left "
                    onClick={handleUpdate}
                    disabled={disabled}
                  >
                    <button className="btnInfo">Update</button>
                  </Col>
                )}
                {!editMode && (
                  <Col xs={6} md={2} lg={2} className="text-left">
                    <button
                      className="btnInfo btn-danger"
                      onClick={canelUpdate}
                    // disabled={disabled}
                    >
                      Cancel
                    </button>
                  </Col>
                )}
                {editMode && (
                  <Row>
                    <Col
                      xs={6}
                      md={{ span: 2, offset: 8 }}
                      lg={{ span: 2, offset: 8 }}
                      className="text-left"
                    >
                      {formInputs?.KYCIndicator === "KYC" && (
                        <>
                          <button className="btnInfo" onClick={handlePrint}>
                            <i className="bi bi-printer"></i> Print KYC
                          </button>
                          <div style={{ display: "none" }}>
                            {/* <PrintKYCRegistration
                              ref={contentRef}
                              data={formInputs}
                            /> */}
                          </div>
                        </>
                      )}
                    </Col>
                    {/* {hasAccess(
                      userRole,
                      "buttons",
                      "customer_details_edit",
                      pageConfigInfo
                    ) && ( */}
                    <Col xs={6} md={2} lg={2} className="text-left">
                      <button className="btnInfo" onClick={editCustomer}>
                        Edit
                      </button>
                    </Col>
                    {/* )} */}
                  </Row>
                )}
              </Row>
            )}
            <Loader isLoading={loading} className={"text-center"} />
            {!loading && (
              <>
                {/* customer details */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                              }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">TD</span>
                        </Col>
                        <Col xs={8} md={8} lg={8}>
                          <span className="headerTitle">Transporter </span>
                          <span className="subHeaderTitle">
                            Transporter Details
                          </span>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                        }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label=" Name"
                              extraLabel="As per the trade license"
                              name="organisationName"
                              placeholder=""
                              value={formInputs?.organisationName || ""}
                              onChange={onInputChange}
                              required={true}
                              error={validation.organisationName}
                              disabled={editMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label=" Address Lines 1 / Street"
                              name="address"
                              placeholder=""
                              value={formInputs?.address || ""}
                              onChange={onInputChange}
                              error={validation.address}
                              required={true}
                              disabled={editMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Address Line 2"
                              name="address2"
                              placeholder=""
                              value={formInputs?.address2 || ""}
                              onChange={onInputChange}
                              error={validation.address2}
                              required={true}
                              disabled={editMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="City"
                              name="city"
                              placeholder=""
                              value={formInputs?.city || ""}
                              onChange={onInputChange}
                              error={validation.city}
                              required={true}
                              disabled={editMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Country"
                              placeholder=""
                              data={getCountry}
                              id="country"
                              iconClassName="dropdownIcon"
                              name="country"
                              code="countryCode"
                              description="countryDesc"
                              setValue={formInputs?.country || ""}
                              getvalue={setDropdownData}
                              required={true}
                              // error={validation.country}
                              disabled={editMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="State"
                              placeholder=""
                              data={getState}
                              id="state"
                              iconClassName="dropdownIcon"
                              name="state"
                              code="stateCode"
                              description="stateDesc"
                              setValue={formInputs?.state}
                              getvalue={setDropdownData}
                              required={true}
                              // error={validation.state}
                              disabled={editMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Postal Code/PO Box"
                              name="cityPostalCode"
                              placeholder=""
                              value={formInputs?.cityPostalCode}
                              onChange={onInputChange}
                              error={validation.cityPostalCode}
                              required={true}
                              disabled={editMode}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Sales Officer Name"
                              extraLabel=""
                              name="salesOfficerName"
                              code="salesOfficerCode"
                              description="salesOfficerDesc"
                              data={SalesOfficerData}
                              id="salesOfficerName"
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.salesOfficerName}
                              error={validation.salesOfficerName}
                              getvalue={setDropdownData}
                              required={true}
                              // className="dropdownOption"
                              disabled={editMode}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Company Code"
                              extraLabel="SAP Company Code"
                              placeholder=""
                              data={getCompanyCode}
                              id="companyCode"
                              iconClassName="dropdownIcon"
                              name="companyCode"
                              code="companyCodeCode"
                              description="companyCodeDesc"
                              setValue={formInputs.companyCode || ""}
                              getvalue={setDropdownData}
                              onChange={onInputChange}
                              // error={validation.companyCode}
                              required={true}
                              disabled={true}
                            />
                          </Col>
                           <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex align-items-center"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="activeInactive"
                              >
                                Active/Inactive
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="activeInactive"
                                id="activeInactive"
                                checked={formInputs?.activeInactive || false}
                                onChange={(e) =>
                                  setFormInputs((prev) => ({
                                    ...prev,
                                    activeInactive: e.target.checked,
                                  }))
                                }
                                disabled={editMode}
                              />
                              <span className="ms-2">
                                {formInputs?.activeInactive
                                  ? "Active"
                                  : "Inactive"}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/*Customer Contact Person / Line Item */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${isCardVisible2
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                              }`}
                            onClick={toggleCardVisibility2}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">CP</span>
                        </Col>
                        <Col xs={4} md={8} lg={8}>
                          <span className="headerTitle"> Contact Person</span>
                          <span className="subHeaderTitle">
                            Customer Contact Person
                          </span>
                        </Col>
                        {!editMode && (
                          <Col xs={4} md={2} lg={2}>
                            <div className="d-flex justify-content-end  p-2 me-3">
                              <button
                                className="btnTable"
                                onClick={addCustomerCantactPerson}
                              >
                                <i className="bi bi-plus-lg"></i> Add
                              </button>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                        }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <div className="accordion-body">
                              <div className="d-flex-column justify-content-center">
                                <Row>
                                  <Col xs={12}>
                                    <div className="accordion-body">
                                      <div className="d-flex-column justify-content-center">
                                        <Row className="pt-4 d-none d-lg-flex ">
                                          <Col xs={12} md={2} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Job Title
                                            </p>
                                          </Col>
                                          <Col xs={12} md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Contact Title
                                            </p>
                                          </Col>
                                          <Col xs={12} md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Contact Person
                                            </p>
                                          </Col>
                                          <Col xs={12} md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Contact Number
                                            </p>
                                          </Col>
                                          <Col xs={12} md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Email-ID
                                            </p>
                                          </Col>
                                          {!editMode && (
                                            <Col xs={12} md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex">
                                                Action
                                              </p>
                                            </Col>
                                          )}
                                        </Row>
                                        {getcustomerContactPerson?.length > 0 &&
                                          getcustomerContactPerson.map(
                                            (doc, index) => (
                                              <Row key={doc.id}>
                                                <Col xs={12}>
                                                  <hr className="mx-4 my-0 text-color-black" />
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={2}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <ComboboxField
                                                    label=""
                                                    placeholder="Contact Position"
                                                    data={getcontactPosition}
                                                    id="contactPosition"
                                                    iconClassName="dropdownIcon"
                                                    name="contactPosition"
                                                    code="contactPositionCode"
                                                    description="contactPositionDesc"
                                                    setValue={
                                                      doc?.contactPosition
                                                    }
                                                    getvalue={setDropdownData}
                                                    index={doc.id}
                                                    onChangeValue={
                                                      handleChangeCustomerContacts
                                                    }
                                                    disabled={editMode}
                                                  />
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={2}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <ComboboxField
                                                    label=""
                                                    placeholder="Contact Title"
                                                    data={getTitle}
                                                    id="contactTitle"
                                                    iconClassName="dropdownIcon"
                                                    name="contactTitle"
                                                    code="contactTitleCode"
                                                    description="contactTitleDesc"
                                                    setValue={doc?.contactTitle}
                                                    getvalue={setDropdownData}
                                                    index={doc.id}
                                                    onChangeValue={
                                                      handleChangeCustomerContacts
                                                    }
                                                    disabled={editMode}
                                                  />
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={2}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <InputField
                                                    className="inputBox mt-1"
                                                    name="contactName"
                                                    placeholder="Contact Person"
                                                    value={
                                                      doc.contactName || ""
                                                    }
                                                    onChange={(e) =>
                                                      handleChangeCustomerContacts(
                                                        doc.id,
                                                        "contactName",
                                                        e.target.value
                                                      )
                                                    }
                                                    disabled={editMode}
                                                  />
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={2}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <InputField
                                                    className="inputBox mt-1"
                                                    name="contactNumber"
                                                    placeholder="Contact Number"
                                                    value={
                                                      doc.contactNumber || ""
                                                    }
                                                    onChange={(e) =>
                                                      handleChangeCustomerContacts(
                                                        doc.id,
                                                        "contactNumber",
                                                        e.target.value
                                                      )
                                                    }
                                                    disabled={editMode}
                                                  />
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={2}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <InputField
                                                    className="inputBox mt-1"
                                                    // label="Please Enter the Remarks*"
                                                    name="contactEmail"
                                                    placeholder="Email"
                                                    value={
                                                      doc.contactEmail || ""
                                                    }
                                                    onChange={(e) =>
                                                      handleChangeCustomerContacts(
                                                        doc.id,
                                                        "contactEmail",
                                                        e.target.value
                                                      )
                                                    }
                                                    disabled={editMode}
                                                  />
                                                </Col>

                                                {!editMode && (
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={1}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <i
                                                      onClick={() =>
                                                        deleteCustomerContactPerosn(
                                                          doc.id
                                                        )
                                                      }
                                                      className="bi bi-trash text-danger fs-4"
                                                    />
                                                  </Col>
                                                )}
                                              </Row>
                                            )
                                          )}
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* customer Doucment Type */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                              }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">DT</span>
                        </Col>
                        <Col xs={4} md={8} lg={8}>
                          <span className="headerTitle"> Doucment Type</span>
                          <span className="subHeaderTitle">Doucment Type</span>
                        </Col>
                        {!editMode && (
                          <Col xs={4} md={2} lg={2}>
                            <div className="d-flex justify-content-end  p-2 me-3">
                              <button
                                className="btnTable"
                                onClick={addDocumentType}
                              >
                                <i className="bi bi-plus-lg"></i> Add
                              </button>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                        }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <div className="accordion-body">
                              <div className="d-flex-column justify-content-center">
                                <Row>
                                  <Col xs={12}>
                                    <div className="accordion-body">
                                      <div className="d-flex-column justify-content-center">
                                        <Row className="pt-4 d-none d-lg-flex ">
                                          <Col xs={12} md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Document Type
                                            </p>
                                          </Col>
                                          <Col xs={12} md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Document Number
                                            </p>
                                          </Col>
                                          <Col xs={12} md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Issue Date
                                            </p>
                                          </Col>

                                          <Col xs={12} md={4} lg={1}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              View Files
                                            </p>
                                          </Col>

                                          {!editMode && (
                                            <>
                                              <Col xs={12} md={4} lg={2}>
                                                <p className="fs-6 fw-medium d-flex ms-4">
                                                  Attachments
                                                </p>
                                              </Col>

                                              <Col xs={12} md={4} lg={2}>
                                                <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                                  Action
                                                </p>
                                              </Col>
                                            </>
                                          )}
                                        </Row>
                                        {getDocumentTypeData?.length > 0 &&
                                          getDocumentTypeData.map(
                                            (doc, index) => (
                                              <Row key={doc.id}>
                                                <Col xs={12}>
                                                  <hr className="mx-4 my-0 text-color-black" />
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={2}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <ComboboxField
                                                    label=""
                                                    placeholder="Document type"
                                                    data={getdocumentType}
                                                    id="documentType"
                                                    iconClassName="dropdownIcon"
                                                    name="documentType"
                                                    code="documentTypeCode"
                                                    description="documentTypeDesc"
                                                    setValue={doc?.documentType}
                                                    getvalue={setDropdownData}
                                                    index={doc.id}
                                                    onChangeValue={
                                                      handleInputChange
                                                    }
                                                    disabled={editMode}
                                                  />
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={2}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <InputField
                                                    className="inputBox"
                                                    placeholder="Document Number"
                                                    value={doc.documentNumber}
                                                    onChange={(e) =>
                                                      handleInputChange(
                                                        doc.id,
                                                        "documentNumber",
                                                        e.target.value
                                                      )
                                                    }
                                                    disabled={editMode}
                                                  />
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={2}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <InputField
                                                    className="inputBox"
                                                    type="date"
                                                    value={doc.issueDate}
                                                    onChange={(e) =>
                                                      handleInputChange(
                                                        doc.id,
                                                        "issueDate",
                                                        e.target.value
                                                      )
                                                    }
                                                    disabled={editMode}
                                                  />
                                                </Col>

                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={1}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <div className="d-flex justify-content-center">
                                                    {doc.iSOCertification && (
                                                      <img
                                                        src="assets/img/newIcons/attached-file.png"
                                                        className="mt-1 attachmentIcon"
                                                        alt="attachments"
                                                        onClick={() =>
                                                          handleViewFile(
                                                            doc.iSOCertification
                                                          )
                                                        }
                                                      />
                                                    )}
                                                  </div>
                                                </Col>

                                                {!editMode && (
                                                  <>
                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <FileUploadComponent
                                                        id={doc.id}
                                                        name="iSOCertification"
                                                        label=""
                                                        allowedTypes={[
                                                          "image/png",
                                                          "image/jpeg",
                                                          "application/pdf",
                                                        ]}
                                                        multiple={true} // Change to `false` for single file selection
                                                        required={true}
                                                        onSuccessUpload={
                                                          onSuccessUploadDocumentType
                                                        }
                                                        value={
                                                          formInputs.iSOCertification ||
                                                          ""
                                                        }
                                                        disabled={editMode}
                                                      />
                                                    </Col>

                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={1}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <i
                                                        onClick={() =>
                                                          deleteDocumentType(
                                                            doc.id
                                                          )
                                                        }
                                                        className="bi bi-trash text-danger fs-4"
                                                      />
                                                    </Col>
                                                  </>
                                                )}
                                              </Row>
                                            )
                                          )}
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* KYC Updated details */}
                {formInputs?.KYCIndicator &&
                  formInputs?.KYCIndicator === "KYC" && (
                    <>
                      {/* Project Completed*/}
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible11
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility11}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">FI</span>
                              </Col>
                              <Col xs={12} md={9} lg={9}>
                                <span className="headerTitle">
                                  Project Completed
                                </span>
                                <span className="subHeaderTitle">
                                  Project Completed
                                </span>
                              </Col>
                              {!editMode && (
                                <Col
                                  xs={12}
                                  md={2}
                                  lg={2}
                                  className="headerButtonAlign"
                                >
                                  <button
                                    className="btnTable"
                                    onClick={addProjecetDocumentItemRow}
                                  >
                                    <i className="bi bi-plus-lg"></i> Add
                                  </button>
                                </Col>
                              )}

                              {/* <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col> */}
                            </Row>
                          </h2>

                          <div
                            className={`accordion-collapse collapse show ${isCardVisible11 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              <Col xs={12} md={12} lg={12}>
                                <DataTable
                                  title=""
                                  columns={projectCompletedCol}
                                  data={getprojectCompletedData}
                                  // progressPending={loading}
                                  // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                                  pagination
                                // paginationServer
                                // paginationTotalRows={totalRows}
                                // onChangeRowsPerPage={handlePerRowsChange}
                                // onChangePage={handlePageChange}
                                // selectableRows
                                // onSelectedRowsChange={handleChange}
                                />
                              </Col>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Project on Hand*/}
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible12
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility12}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">FI</span>
                              </Col>
                              <Col xs={12} md={9} lg={9}>
                                <span className="headerTitle">
                                  Project on Hand
                                </span>
                                <span className="subHeaderTitle">
                                  Project on Hand
                                </span>
                              </Col>
                              {!editMode && (
                                <Col
                                  xs={12}
                                  md={2}
                                  lg={2}
                                  className="headerButtonAlign"
                                >
                                  <button
                                    className="btnTable"
                                    onClick={
                                      addprojectDetailContactPersonItemRow
                                    }
                                  >
                                    <i className="bi bi-plus-lg"></i> Add
                                  </button>
                                </Col>
                              )}

                              {/* <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col> */}
                            </Row>
                          </h2>

                          <div
                            className={`accordion-collapse collapse show ${isCardVisible12 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              <Row>
                                <Col xs={12} md={12} lg={12}>
                                  <DataTable
                                    title=""
                                    columns={projectOnHandCol}
                                    data={getProjectOnHandData}
                                    // progressPending={loading}
                                    // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                                    pagination
                                  // paginationServer
                                  // paginationTotalRows={totalRows}
                                  // onChangeRowsPerPage={handlePerRowsChange}
                                  // onChangePage={handlePageChange}
                                  // selectableRows
                                  // onSelectedRowsChange={handleChange}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* RichTextEditor */}
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible6
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility6}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">RE</span>
                              </Col>
                              <Col xs={8} md={9} lg={9}>
                                <span className="headerTitle">Remarks</span>
                                <span className="subHeaderTitle">Remarks</span>
                              </Col>
                            </Row>
                          </h2>

                          <div
                            className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              <Row className="p-4">
                                <Col xs={12} md={12} lg={12}>
                                  <RichTextEditor
                                    value={getCustomerProfile}
                                    onChange={handleEditorChange}
                                    readOnly={editMode}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                {/* 08 Banker Info*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${isCardVisible8
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                              }`}
                            onClick={toggleCardVisibility8}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">BK</span>
                        </Col>
                        <Col xs={4} md={8} lg={4}>
                          <span className="headerTitle">Bank Information</span>
                          <span className="subHeaderTitle">
                            Bank Information (Please add all your Bank Accounts)
                          </span>
                        </Col>
                        {/* <Col xs={4} md={2} lg={2} className="">
                                      <button
                                        className="btnTable"
                                        onClick={() => addBankForm()}
                                        disabled={getDisabledStatus}
                                      >
                                        <i className="bi bi-plus-lg"></i> Add Bank Info
                                      </button>
                                    </Col> */}

                        {/* <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col> */}
                      </Row>
                    </h2>

                    {/* Banker Information */}
                    <div
                      className={`accordion-collapse collapse show ${isCardVisible8 ? "visible" : ""
                        }`}
                    >
                      <div className="accordion-body">
                        {/* To Load Dynamic Bank Info Form */}
                        {getBankDetails &&
                          getBankDetails?.map((item, index) => (
                            <div key={index}>
                              <Row className="pt-2 pb-2">
                                <Col
                                  xs={12}
                                  md={12}
                                  lg={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <h6>Bank Information Section {index + 1}</h6>
                                  {/* <span
                                                className="deleteIconAccordion"
                                                onClick={() => removeBankForm(index)}
                                              >
                                                {" "}
                                                <i className="bi bi-x-circle"></i>{" "}
                                              </span> */}
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Is the Company bank included on list?"
                                    placeholder=""
                                    // data={dropdownOption}
                                    id="bankNotListed"
                                    iconClassName="dropdownIcon"
                                    name="bankNotListed"
                                    setValue={item?.bankNotListed || ""}
                                    getvalue={setDropdownData}
                                    index={index}
                                    // onChangeValue={handleChangeBankInfo}
                                    disabled={editMode}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="BankID"
                                    placeholder=""
                                    data={getBankDetailsData}
                                    id="bankKey"
                                    iconClassName="dropdownIcon"
                                    name="bankKey"
                                    setValue={item?.bankKey}
                                    getvalue={setDropdownData}
                                    index={index}
                                    // onChangeValue={handleChangeBankInfo}
                                    disabled={editMode}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Bank A/C Number"
                                    name="bankAccountNumber"
                                    placeholder=""
                                    value={item?.bankAccountNumber}
                                    // onChange={(e) =>
                                    //   handleChangeBankInfo(
                                    //     index,
                                    //     "bankAccountNumber",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={editMode}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {/* <ComboboxField
                                                label="Bank Name"
                                                placeholder=""
                                                data={dropdownOption}
                                                id="bankName"
                                                iconClassName="dropdownIcon"
                                                name="bankName"
                                                setValue={item?.bankName || ""}
                                                getvalue={setDropdownData}
                                                index={index}
                                                onChangeValue={handleChangeBankInfo}
                                                disabled={editMode}
                                              /> */}

                                  <InputField
                                    className="inputBox"
                                    label="Bank Name"
                                    name="bankBranchName"
                                    placeholder=""
                                    value={item?.bankBranchName}
                                    // onChange={(e) =>
                                    //   handleChangeBankInfo(
                                    //     index,
                                    //     "bankBranchName",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {/* <ComboboxField
                                                label="Bank Country"
                                                placeholder=""
                                                data={dropdownOption}
                                                id="bankCountry"
                                                iconClassName="dropdownIcon"
                                                name="bankCountry"
                                                setValue={item?.bankCountry || ""}
                                                getvalue={setDropdownData}
                                                index={index}
                                                onChangeValue={handleChangeBankInfo}
                                                disabled={editMode}
                                              /> */}
                                  <InputField
                                    className="inputBox"
                                    label="Bank Country"
                                    name="bankCountryDescription"
                                    placeholder=""
                                    value={item?.bankCountryDescription}
                                    // onChange={(e) =>
                                    //   handleChangeBankInfo(
                                    //     index,
                                    //     "bankCountryDescription",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {/* <ComboboxField
                                                label="Branch Address"
                                                placeholder=""
                                                data={dropdownOption}
                                                id="bankAddress"
                                                iconClassName="dropdownIcon"
                                                name="bankAddress"
                                                setValue={item?.bankAddress || ""}
                                                getvalue={setDropdownData}
                                                index={index}
                                                onChangeValue={handleChangeBankInfo}
                                                disabled={editMode}
                                              /> */}
                                  <InputField
                                    className="inputBox"
                                    label="Branch Address"
                                    name="bankAddress"
                                    placeholder=""
                                    value={item?.bankAddress}
                                    // onChange={(e) =>
                                    //   handleChangeBankInfo(
                                    //     index,
                                    //     "bankAddress",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={editMode}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {/* <ComboboxField
                                                label="Preferred Currency"
                                                placeholder=""
                                                data={dropdownOption}
                                                id="preferredCurrency"
                                                iconClassName="dropdownIcon"
                                                name="preferredCurrency"
                                                setValue={item?.preferredCurrency || ""}
                                                getvalue={setDropdownData}
                                                index={index}
                                                onChangeValue={handleChangeBankInfo}
                                                disabled={editMode}
                                              /> */}
                                  <InputField
                                    className="inputBox"
                                    label="Preferred Currency"
                                    name="bankCurrency"
                                    placeholder=""
                                    value={item?.bankCurrency}
                                    // onChange={(e) =>
                                    //   handleChangeBankInfo(
                                    //     index,
                                    //     "bankCurrency",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={true}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Name of Beneficiary"
                                    extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                    name="AccountHolderName"
                                    placeholder=""
                                    value={item?.AccountHolderName}
                                    // onChange={(e) =>
                                    //   handleChangeBankInfo(
                                    //     index,
                                    //     "AccountHolderName",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={editMode}
                                  />
                                  {/* <ComboboxField
                                                label="Name of Beneficiary"
                                                placeholder=""
                                                extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                                data={dropdownOption}
                                                id="AccountHolderName"
                                                iconClassName="dropdownIcon"
                                                name="AccountHolderName"
                                                setValue={item?.AccountHolderName || ""}
                                                getvalue={setDropdownData}
                                                index={index}
                                                onChangeValue={handleChangeBankInfo}
                                                disabled={getDisabledStatus}
                                              /> */}
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Swift IFSC Code"
                                    placeholder=""
                                    // data={dropdownOption}
                                    id="swiftIfscCode"
                                    iconClassName="dropdownIcon"
                                    name="swiftIfscCode"
                                    setValue={item?.swiftIfscCode || ""}
                                    getvalue={setDropdownData}
                                    index={index}
                                    // onChangeValue={handleChangeBankInfo}
                                    disabled={editMode}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Company letterhead"
                                    extraLabel="Upload the filled template on company letterhead , signed by authorized person with company seal "
                                    name="bankCompanyletterhead"
                                    placeholder=""
                                    value={item?.bankCompanyletterhead}
                                    // onChange={(e) =>
                                    //   handleChangeBankInfo(
                                    //     index,
                                    //     "bankCompanyletterhead",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={editMode}
                                  />
                                  <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Confirmation letter"
                                    extraLabel="Do you have a Confirmation letter from the bank( mandatory for bank updates ) "
                                    name="bankConfirmationLetter"
                                    placeholder=""
                                    value={item?.bankConfirmationLetter}
                                    // onChange={(e) =>
                                    //   handleChangeBankInfo(
                                    //     index,
                                    //     "bankConfirmationLetter",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={editMode}
                                  />
                                  <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={12}
                                  lg={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <hr />
                                </Col>
                              </Row>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <ApproveRemarksModal
        show={modalShowApprove}
        onHide={() => hideModalApprove()}
        onvaluechange={handleValueChange}
      />

      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default PlTransporterRegistrationDetails;
